import { FC, ReactNode, useId } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import CustomButton from '../CustomButton';
import styles from './ConfirmActionModal.module.scss';

export type ConfirmActionModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  description: ReactNode;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isConfirming?: boolean;
  confirmingLabel?: string;
  zIndex?: number;
};

const ConfirmActionModal: FC<ConfirmActionModalProps> = ({
  open,
  onClose,
  onConfirm,
  description,
  title = 'Are you sure?',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  isConfirming = false,
  confirmingLabel = 'Deleting...',
  zIndex,
}) => {
  const titleId = useId();
  const descriptionId = useId();

  const handleConfirm = () => {
    void onConfirm();
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        if (!isConfirming) onClose();
      }}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      sx={{
        ...(zIndex != null ? { zIndex } : {}),
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(34, 43, 58, 0.2)',
        },
      }}
    >
      <Box className={styles.confirmModal}>
        <Box className={styles.confirmModalClose}>
          <CloseIcon
            sx={{ width: 30, height: 30 }}
            onClick={() => {
              if (!isConfirming) onClose();
            }}
          />
        </Box>

        <Box className={styles.confirmModalContent}>
          <Typography
            id={titleId}
            variant="h5"
            sx={{ fontWeight: 'bold', textAlign: 'center', color: '#222B3A' }}
          >
            {title}
          </Typography>
          <Typography
            id={descriptionId}
            variant="body1"
            sx={{ color: '#222B3A', textAlign: 'center' }}
          >
            {description}
          </Typography>

          <Box className={styles.confirmModalActions}>
            <CustomButton
              variant="outlined"
              onClick={onClose}
              disabled={isConfirming}
            >
              {cancelLabel}
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={handleConfirm}
              disabled={isConfirming}
              customClass={styles.confirmDangerButton}
            >
              {isConfirming ? confirmingLabel : confirmLabel}
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmActionModal;
